import Royal from "../Images/Project Img/Royal x img.png";
import Rental from "../Images/Project Img/Rental cars.png";
import Youcan from "../Images/Project Img/Youcanuse.png";
export const PortfolioData = [
  {
    id: "1",
    project_name: "ROYAL",
    project_name_span: "X",
    description:
      "Royal X is provides an end-to-end IT infrastructure solution to businesses of all sizes. The organization is also committed to sustainability, and its solutions are meant to help achieve high levels of efficiency. Our main focus is creating and....",
    class_name: "royalx",
    img: Royal,
    url: "",
    software: "",
  },
  {
    id: "2",
    project_name: "RENTAL",
    project_name_span: "CARS",
    description:
      "A Rental car website is an online platform that allows users to rent cars for personal or business use. The website provides an interface for searching, comparing, and reserving cars.",
    class_name: "rental-car",
    img: Rental,
    url: "",
    software: "",
  },
  {
    id: "3",
    project_name: "YOUCANUSE",
    description:
      "At YouCanUse, we are excited to showcase a collection of my little projects that reflect my passion for front-end development and UX design. This website serves as a hub for my creative endeavors and allows me to share my work with the world.",
    class_name: "youcanuse",
    img: Youcan,
    url: "",
    software: "",
  },
];

export default PortfolioData;
